module.exports = __webpack_public_path__ + "img/t02.533f1db6.jpg";